import axios from "axios";
import { Store } from "./Store";
import { refreshtoken } from './actions/LoginActions';
import { logoutUser } from './actions/UserActions';
import { setError } from "./actions/LoginActions"
import history from "history.js";


const dateTransformer = data => {
  if (data instanceof Date) {
    // do your specific formatting here
    return data.toLocaleString()
  }
  if (Array.isArray(data)) {
    return data.map(val => dateTransformer(val))
  }
  if (typeof data === "object" && data !== null) {
    return Object.fromEntries(Object.entries(data).map(([ key, val ]) =>
      [ key, dateTransformer(val) ]))
  }
  return data
}

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

// Add a request interceptor to add a default authorization header.
instance.interceptors.request.use(
    config => {
        const token = Store.getState().login.token;
        config.headers.Authorization = token ? `Bearer ${token}` : '';
        instance.defaults.headers.common['Authorization'] = token ? `Bearer ${token}` : '';
        return config;
    },
    error => Promise.reject(error)
  );

  // Response interceptor for API calls
  instance.interceptors.response.use((response) => {
    return response
  }, async function (error) {
    const originalRequest = error.config;
    const refreshToken = Store.getState().login?.refreshtoken;
    if (error.response && error.response.status === 401 && !originalRequest._retry && refreshToken) {
      originalRequest._retry = true;
      try {
        const access_token = await Store.dispatch(refreshtoken(refreshToken));
        if (access_token) {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + access_token;
          return instance(originalRequest);
        }
      } catch (e) {
        // Refresh failed; reject so caller sees 401
      }
    }
    return Promise.reject(error);
  });

export default instance;

export const HeaderContentTypeJson = () => {
    return {
        headers: {
            'content-type': 'application/json',
        }
    }
};

export const globalErrorHandler = async (error) => {
  if (!error || !error.response) return;
  const status = error.response.status;
  if (status === 401 || status === 500) {
    Store.dispatch(logoutUser("Your session has expired."));
    Store.dispatch(setError("Your session has expired."));
  }
  if (status === 403) {
    Store.dispatch(setError("You do not have permission for this action."));
  }
  if (status === 415) {
    Store.dispatch(setError("Request format not supported. Please try again."));
  }
};